import { RelatedToType } from 'app/shared/enums';
import { CustomObject } from 'app/shared/modules/custom-objects/custom-objects.types';

export type TaskRole = {
  id: number;
  created_at: string;
  account_id: number;
  name: string;
  applicable_type: RelatedToType;
  errors?: string[];
  mapping: TaskRoleMapping | TaskRoleMappingCreate;
};

export type TaskRoleMapping = {
  id?: number;
  user_id: number;
  task_role_id: number;
  related_to_type: RelatedToType;
  related_to_id: number;
  isNew?: boolean;
  errors?: string[];
};

export type TaskRoleCreate = {
  accountId: string;
  applicable_type: RelatedToType;
  name: string;
};

export type TaskRoleMappingCreate = {
  related_to_type: RelatedToType;
  related_to_id: number;
  user_id: number;
  task_role_id: number;
};

export type TaskRoleCreateResponse = {
  task_role: TaskRole;
};

export type TaskRoleMappingCreateResponse = {
  task_role_mapping: TaskRoleMapping;
};

export type TaskRoleGetResponse = {
  task_roles: TaskRole[];
};

export type TaskRoleMappingGetResponse = {
  task_role_mappings: TaskRoleMapping[];
};

export type TaskRolesResolverData = {
  customObjects: CustomObject[];
  relatedToTypes: RelatedToType[];
};

export enum CommonAction {
  roleSearch = 'roleSearch',
  addRole = 'addRole',
  setLoading = 'setLoading',
}

export const routeTypeMap = {
  propertytenant: 'PropertyTenant',
  propertyunit: 'PropertyUnit',
  facilityreport: 'FacilityReport',
  loanquote: 'LoanQuote',
};
